
import { Vue, Component } from 'vue-property-decorator';
import { List } from 'vant';
import NewsItem from '@/components/News/NewsItem .vue';
import { getNewsList } from '../api';
Vue.use(List);
@Component({
  components: {
    NewsItem,
  },
})
export default class News extends Vue {
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;
  showList = true;
  newsId = process.env.NODE_ENV === 'development' ? '3250' : '10340';
  tabs = ['区县心愿清单', '动态新闻'];
  activeIndex = '区县心愿清单';

  goDetail(a: any) {
    const url = a.targetUrl;
    window.location.href = url;
  }
  onLoad() {
    const data = {
      page: this.page,
      pageSize: 10,
      columnId: this.activeIndex === '区县心愿清单' ? 1604 : 1488,
    };
    getNewsList(data).then((res: any) => {
      this.endListData(res);
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (res.statusCode !== 200) {
      this.finished = true;
    } else {
      if (!res.data.list || res.data.list.length === 0) {
        this.finished = true;
      } else {
        if (!res.data.list || res.data.list.length === 0) {
          this.finished = true;
        } else {
          this.list = [...this.list, ...res.data.list];
        }
      }
    }
    this.loading = false;
  }
  classArr(index: string) {
    if (index === this.activeIndex) {
      return ['tab-item', 'tab-item-active'];
    }
    return ['tab-item'];
  }
  changeType(type: string) {
    if (this.activeIndex === type || this.loading) {
      return;
    }
    this.activeIndex = type;
    this.showList = false;
    this.list = [];
    this.loading = false;
    this.page = 1;
    this.finished = false;
    setTimeout(() => {
      this.showList = true;
    }, 50);
  }
}
